export function checkoutWorkKey(row) {
  if (!row) return null;
  if (row.work_key) return row.work_key;
  if (row.procedure_visit_id) return `pv:${row.procedure_visit_id}`;
  if (row.tn_id) return `tn:${row.tn_id}`;
  if (row._localId) return `local:${row._localId}`;
  return null;
}

function fallbackCheckoutWorkKey(row, index = 0) {
  const direct = checkoutWorkKey(row);
  if (direct) return direct;
  const proc = row?.procedure_id || row?.procedure_code || row?.procedure_name || row?.custom_name || "procedure";
  const tooth = row?.tooth_number || row?.tooth || "general";
  const surface = row?.surface || row?.surfaces || "";
  return `item:${index}:${proc}:${tooth}${surface ? `:${surface}` : ""}`;
}

function sameStableId(a, b, field) {
  const av = a?.[field];
  const bv = b?.[field];
  if (av === null || av === undefined || av === "") return false;
  if (bv === null || bv === undefined || bv === "") return false;
  return String(av) === String(bv);
}

export function sameCheckoutWork(a, b) {
  const ak = checkoutWorkKey(a);
  const bk = checkoutWorkKey(b);
  if (ak && bk && ak === bk) return true;
  return sameStableId(a, b, "procedure_visit_id")
    || sameStableId(a, b, "tn_id")
    || sameStableId(a, b, "treatment_plan_item_id")
    || sameStableId(a, b, "procedure_instance_id")
    || sameStableId(a, b, "charge_event_id");
}

export function buildPostOpSuggestions({
  items = [],
  scheduled = [],
  postOpByProcedure = {},
  followupWaivers = {},
} = {}) {
  const out = [];
  for (const [index, it] of (items || []).entries()) {
    const outcome = it.outcome || "done";
    if (outcome !== "done") continue;
    const procId = it.procedure_id;
    if (!procId) continue;
    const cfg = postOpByProcedure?.[procId];
    if (!cfg) continue;

    const sourceKey = fallbackCheckoutWorkKey(it, index);
    if (!sourceKey) continue;

    let waiverKey = sourceKey;
    for (const s of scheduled || []) {
      if (sameCheckoutWork(it, s)) {
        waiverKey = checkoutWorkKey(s) || sourceKey;
        break;
      }
    }
    if (followupWaivers?.[waiverKey]?.waived || followupWaivers?.[sourceKey]?.waived) continue;

    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + (Number(cfg.after_days) || 7));
    out.push({
      key: sourceKey,
      source_item_key: sourceKey,
      source_procedure_visit_id: it.procedure_visit_id || null,
      sourceName: it.procedure_name || it.custom_name || "Procedure",
      sourceTooth: it.tooth_number || null,
      followup_procedure_id: cfg.followup_procedure_id,
      followup: cfg.followup_procedure_name,
      followup_duration_min: Number(cfg.followup_duration_min) || 15,
      followup_category: cfg.followup_category,
      days: Number(cfg.after_days) || 7,
      dueDate,
    });
  }
  return out;
}
